import get from 'lodash.get';
import { createSelector } from 'reselect';

// Store
import Global from '../../../store/global-selectors';
import * as JobPipelineActions from '../../../store/job-pipeline/job-pipeline.actions';
import * as LabelActions from '../../../store/labels/labels.actions';
import * as ShipmentActions from '../../../store/shipments/shipments.actions';
import * as SelectedShipmentActions from '../../../store/shipments/selected-shipments/shipments.selected-shipments.actions';

const getFulfillmentIdsFromVoidWarningsMap = (voidWarning) => get(voidWarning, 'fulfillment.fulfillmentId');

const retryFulfillmentIdsSelector = createSelector(
  (voidWarnings) => voidWarnings,
  (voidWarnings) => voidWarnings.map(getFulfillmentIdsFromVoidWarningsMap),
);

export const LoadDataToVoidModalStep = (state, jobId) => {
  const jobData = Global.selectJobPipelineJobDataByJobId(state, { jobId });
  const { successfullyVoided, voidWarnings } = jobData;
  const retryFulfillmentIds = retryFulfillmentIdsSelector(voidWarnings);

  return [
    LabelActions.loadBulkVoidResponse(voidWarnings, successfullyVoided),
    SelectedShipmentActions.setSelectedShipments(retryFulfillmentIds),
    ShipmentActions.silentRequestGetShipments(),
    JobPipelineActions.updateJob(jobId, {
      fulfillmentIds: retryFulfillmentIds,
    }),
  ];
};
